import { enumSchema, objectSchema } from "vue-utils"
import { CardinalDirection } from "./CardinalDirection"
import { SeaState } from "./SeaState"

export interface WeatherConditions {
	seaState: SeaState

	windDirection: CardinalDirection

	windSpeedKnots: number

	/** Visibility in nautical miles */
	visibilityNm: number
}

export const WeatherConditions = objectSchema<WeatherConditions>({
	seaState: enumSchema(SeaState),
	windDirection: enumSchema(CardinalDirection),
	windSpeedKnots: Number,
	visibilityNm: Number,
})
